import script from "./InfoButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoButton.vue?vue&type=script&setup=true&lang=ts"

import "./InfoButton.vue?vue&type=style&index=0&id=ea6564b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea6564b2"]])

export default __exports__